import React from 'react';
import './StatusTracker.css';

const steps = [
  { status: 'pending', label: 'Puja booked but not confirmed' },
  { status: 'confirmed', label: 'Booking Confirmed' },
  { status: 'acharya_assigned', label: 'Acharya ji Assigned' },
  { status: 'samagri_delivered', label: 'Samagri Delivered' },
  { status: 'puja_started', label: 'Puja Started' },
  { status: 'puja_completed', label: 'Puja Completed' },
  { status: 'cancelled', label: 'Puja Cancelled' }
];

const StatusTracker = ({ currentStatus, previousStatus }) => {
  let displaySteps;

  if (currentStatus === 'cancelled') {
    // Find the index of the previous status
    const previousIndex = steps.findIndex(step => step.status === previousStatus);
    // Include all statuses up to the previous one, and add the cancelled status
    displaySteps = [...steps.slice(0, previousIndex + 1), steps.find(step => step.status === 'cancelled')];
  } else if(currentStatus === 'refund_done' || currentStatus === 'refund_initiate') {
    displaySteps = [
      { status: 'cancelled', label: 'Puja Cancelled' },
      { status: 'refund_initiate', label: 'Refund Initiated' },
      { status: 'refund_done', label: 'Refund Processed' },
    ]
  } else {
    // Show all statuses for non-cancelled cases
    displaySteps = steps;
  }

  const currentIndex = displaySteps.findIndex(step => step.status === currentStatus);

  return (
    <div className="status-tracker">
      {displaySteps.map((step, index) => (
        <div key={step.status} className={`step ${index <= currentIndex ? 'completed' : ''}`}>
          <div className="circle">{index + 1}</div>
          <div className="label">{step.label}</div>
          {index < displaySteps.length - 1 && <div className="line"></div>}
        </div>
      ))}
    </div>
  );
};



export default StatusTracker;
